import { render, staticRenderFns } from "./Addpermohonan.vue?vue&type=template&id=dd0d22d2&"
import script from "./Addpermohonan.vue?vue&type=script&lang=js&"
export * from "./Addpermohonan.vue?vue&type=script&lang=js&"
import style0 from "./Addpermohonan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports